import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const Button = forwardRef(({
    action    = () => {},
    children  = null,
    className = null,
    href      = null,
    type      = null,
    ...remainingProps
}, ref) => {
    // misc
    const Component = href ? 'a' : 'button';

    const defaultAttributes = { type: type || Component === 'a' ? null : 'button' };
    const defaultClasses = [Component === 'a' ? 'link-reset inline-flex space-between' : 'form-field-reset flex space-between items-center cursor-pointer'];

    if (className) {
        defaultClasses.push(className);
    }

    // render
    return (
        <Component
            className={defaultClasses.join(' ')}
            href={href}
            onClick={action}
            ref={ref}
            {...defaultAttributes}
            {...remainingProps}>
            {children}
        </Component>
    );
});

Button.displayName = 'Button';

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    action   : PropTypes.func,
    children : PropTypes.any,
    className: PropTypes.string,
    href     : PropTypes.string,
    type     : PropTypes.string
};

Button.propTypes = propTypes;

export { Button };

export default Button;
